import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import PrivcyPolicy from './components/Policy.js';

const index = () => {
  useEffect(() => {
    document.title = 'Privacy Policy - Elite Hindu Matrimony';
  }, []);

  return (
    <>
      <Layout
        // sider={true}
        hideHeader={true}
      >
        <PrivcyPolicy />
      </Layout>
    </>
  );
};

export default index;
